import { withInstall } from '@vuesax-plus/utils'
import Card from './src/card.vue'

export const VsCard = withInstall(Card)
export default VsCard

export * from './src/card'
